// extracted by mini-css-extract-plugin
export default {"item-border-bottom":"item-border-bottom_RFc6CRPW"};